import React from 'react'
import resumeData from '../resumeData'


const Education = () => {
        return (
            <section id='education'  className='education'>
                <div className="education__header u-margin-left-medium u-margin-top-small">
                    <span className="heading-title ">Education</span>
                </div>
                <div className="education__container reveal">
                    <div className="education__container__body">
                        <h2 className='heading-sub-title'>{resumeData && resumeData.education[0]?.name}</h2>
                        <span>•</span>
                        <span className='heading-sub-title'>{resumeData && resumeData.education[0]?.MonthOfStarting} {resumeData.education[0].YearOfStarting}</span>
                    </div>
                </div>
            </section>
        )
}

export default Education